<template>
  <div class="auth-layout">
    <div class="nav d-lg-none"><router-link :class="logoClass" :to="{path: '/'}"></router-link></div>
    <div class="main row">
      <div class="auth-content col-lg-6 col-12">
        <vuestic-pre-loader v-show="isLoading" ref="preLoader" class="pre-loader"></vuestic-pre-loader>
        <router-view v-show="!isLoading"></router-view>
      </div>
      <div class="auth-wallpaper col-6 d-none d-lg-flex">
        <router-link :class="logoClass" :to="{path: '/'}"></router-link>
      </div>
    </div>
  </div>
</template>

<script>
  import {mapGetters} from 'vuex'
  import ThemeService from '../../services/ThemeService'

  export default {
    name: 'AuthLayout',
    data () {
      return {
        currentTheme: 'fractel'
      }
    },
    computed: {
      ...mapGetters([
        'isLoading'
      ]),
      logoClass () {
        return `${this.currentTheme}-logo`
      }
    },
    mounted () {
      this.currentTheme = ThemeService.currentTheme
      // Listen for theme changes
      this.$root.$on('theme-changed', this.updateTheme)
    },
    beforeDestroy () {
      this.$root.$off('theme-changed', this.updateTheme)
    },
    methods: {
      updateTheme () {
        this.currentTheme = ThemeService.currentTheme
      }
    }
  }
</script>

<style lang="scss">
  @import '../../sass/variables';
  @import '~bootstrap/scss/mixins/breakpoints';
  @import "~bootstrap/scss/functions";
  @import '~bootstrap/scss/variables';
  .auth-layout {
    height: 100vh;
    margin: 0;
    .nav {
      display: flex;
      align-items: center;
      justify-content: center;
      height: $top-mobile-nav-height;
      background-color: $top-nav-bg;
      .i-vuestic {
        height: $auth-mobile-nav-ivuestic-h;
        width: 100%;
      }
      .fractel-logo, .fonestorm-logo {
        height: 6em;
        width: 12em;
      }
    }
    .main {
      margin: 0;
      height: 100%;
      .auth-content {
        padding: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: white;
      }
      .auth-wallpaper {
        background-color: $top-nav-bg;
        overflow: hidden;
        display: flex;
        align-items: center;
        justify-content: center;
        .i-vuestic {
          z-index: 2;
          height: $auth-wallpaper-ivuestic-h;
          width: 100%;
        }
        .oblique {
          position: absolute;
          background-color: $auth-wallpaper-oblique-line;
          left: calc(50% - 27%/2);
          transform: rotate(15deg);
          width: 27%;
          height: 115%;
        }
        .fractel-logo, .fonestorm-logo {
          height: 8em;
          width: 24em;
        }
      }
    }

    @include media-breakpoint-down(md) {
      .main {
        height: $auth-mobile-main-h;
        .auth-content {
          align-items: flex-start;
          padding-top: $auth-content-padding-t;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/layout/AuthLayout.vue